import { render, staticRenderFns } from "./DiscrepancyTypeFilter.vue?vue&type=template&id=553e9118&"
import script from "./DiscrepancyTypeFilter.vue?vue&type=script&lang=js&"
export * from "./DiscrepancyTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports